import { EnvVar } from 'data';
import { DefaultStepProps } from '../../ui/form/multi/types';
import { EnvVariables } from '../../environment-variables-fields';

interface EnvVarsStepProps<T> extends DefaultStepProps<T> {
  isLoading: boolean;
}

export function EnvVarsStep<T extends { envVars: EnvVar[] }>({
  form: { values, setFieldValue, errors },
  isLoading,
}: EnvVarsStepProps<T>) {
  return (
    <EnvVariables
      isLoading={isLoading}
      envVars={values.envVars}
      setFieldValue={setFieldValue}
      errors={errors?.envVars as string}
    />
  );
}

export { type EnvVarsSchema, EnvVarsSchemaValidation } from './EnvVarsSchema';
